import {useSessionStore} from '@netx/core-auth-next/store';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {NetxThemeMode} from '../constants';
import type {ThemeMode} from '../types';
import {getBrowserPreferedThemeMode} from './getBrowserPreferedThemeMode';

const THEME_MODES = Object.values(NetxThemeMode);

export const netxThemeModeToThemeMode = (
	mode?: NetxThemeMode | string,
): ThemeMode => {
	// No `dark` support for portal or login screens currently
	// TODO: discuss opening this up to dark mode for non portal token related links?
	if (isBrandPortal() || useSessionStore.getState().isToken || !useSessionStore.getState().isAuthorized)
		return NetxThemeMode.LIGHT;

	return !mode ||
		mode === NetxThemeMode.DEFAULT ||
		!THEME_MODES.includes(mode as NetxThemeMode)
		? getBrowserPreferedThemeMode()
		: (mode as ThemeMode);
};
